import { gql } from '@apollo/client/core';

export const GET_LOCATIONS = gql`
  query GetLocations {
    locations {
      id
      title
      opened_from
      closed_from
    }
  }
`;
